import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Form, Input } from "antd";
import { observer } from "mobx-react";
import { qaAnswersStore } from "../Stores/QAAnswersStore";
import { ButtonsRow } from "Components/Form/ButtonsRow";
import { Button } from "Components/General/Button";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { I18N_NS } from "Config/i18n";

interface QAAnswerEditFormProps extends WithTranslation, ModalComponentProps {
  answerId: number;
  role: API_QA_ROLE;
}

export const QAAnswerEditForm = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<QAAnswerEditFormProps> {
      handleSubmit = async (values) => {
        const { role } = this.props;

        try {
          await qaAnswersStore.put(this.props.answerId, values, { role });
          this.props.hideModal();
        } catch (err) {
          throw err;
        }
      };

      render() {
        const { t, answerId } = this.props;
        const answerObject = qaAnswersStore.find(answerId, "id");
        return (
          <Form onFinish={this.handleSubmit}>
            <Form.Item
              label={t("Answer")}
              name="answer"
              initialValue={answerObject && answerObject.answer}
              rules={[{ required: true }]}
            >
              <Input.TextArea autoSize={{ minRows: 3 }} />
            </Form.Item>
            <ButtonsRow>
              <Button loading={qaAnswersStore.state === "LOADING"} type="primary" htmlType="submit">
                {t("Save")}
              </Button>
            </ButtonsRow>
          </Form>
        );
      }
    }
  )
);
